// Sons das notificações push. O navegador não deixa a notificação tocar um
// som próprio, então o service worker avisa a aba aberta da Spectrum
// ({ source: 'spectrum-push', type }) e ela toca o arquivo do tipo.
const SOUNDS = {
    sale: "/sounds/sale.mp3",          // venda aprovada (PIX e cartão)
    bot_offline: "/sounds/error.wav",  // bot ficou offline
};

export function playNotificationSound(type) {
    const src = SOUNDS[type];
    if (!src) return Promise.resolve(false);
    try {
        const audio = new Audio(src);
        audio.volume = 0.9;
        // Pode ser bloqueado pela política de autoplay se a página ainda não teve
        // nenhuma interação do usuário — nesse caso só a notificação aparece.
        return audio.play().then(() => true).catch(() => false);
    } catch {
        return Promise.resolve(false);
    }
}

// Escuta o service worker e toca o som do push. Retorna a função de limpeza.
export function listenPushSounds() {
    if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return () => {};
    const handler = (event) => {
        const data = event.data || {};
        if (data.source === "spectrum-push") playNotificationSound(data.type);
    };
    navigator.serviceWorker.addEventListener("message", handler);
    return () => navigator.serviceWorker.removeEventListener("message", handler);
}
